module.exports = __webpack_public_path__ + "static/ranking2.ca585d45.svg";